import { X } from "react-feather";
import "../../css/SideDrawer.css";
import { Drawer } from "@mui/material";

const SideDrawer = ({
  open,
  handleDrawerClose,
  head,
  body,
  style,
  showCloseIcon = true,
}) => {
  return (
    <Drawer anchor="right" open={open}>
      <div
        className="side-drawer"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="side-drawer-close-container">
          {showCloseIcon && (
            <X
              size={30}
              onClick={handleDrawerClose}
              className="side-drawer-close"
            />
          )}
        </div>
        <div style={style}>
          {head}
          {body}
        </div>
      </div>
    </Drawer>
  );
};

export default SideDrawer;
